import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useAppNavigate from "../components/router/use-app-navigate";
import AuthContext from "../components/auth-context";
import Form from "../components/inputs/form";
import Textarea from "../components/inputs/textarea";
import Textbox from "../components/inputs/textbox";
import FileApi from "../api/file";
import VerifyNumber from "../components/signup/verify-number";
import NewRequestResendCodeApi from "../api/newRequest-resendCode";
import { localizeNumbers } from "../functions";
import { Link } from "react-router-dom";

interface RequestForm {
  type?: string;
  phone?: string;
  subCenterId?: string;
  agentCode: string;
  ownershipType?: string;
  installAddress: string;
}

function RequestFd() {
  const { register, handleSubmit } = useForm<RequestForm>();
  const [agentCode, setAgentCode] = useState("");
  const [installAddress, setInstallAddress] = useState("");
  const [toggle, setToggle] = useState(true);
  const [isVerifying, setIsVerifying] = useState(false);
  const navigate = useAppNavigate();
  const { t } = useTranslation(undefined, { keyPrefix: "Request.Fd" });

  const context = useContext(AuthContext);
  const { customerInfo } = context;

  const onSubmit: (data: any) => Promise<string> = async ({
    agentCode,
    installAddress,
  }) => {
    setAgentCode(agentCode);
    setInstallAddress(installAddress);

    const newRequestApi = new NewRequestResendCodeApi(context);
    return newRequestApi.get("FD-LTE").then((response) => {
      if (response.errorMessage == null) setIsVerifying(true);
      return response.errorMessage;
    });
  };

  const onVerifyNumberSubmit = async () => {
    try {
      const fileApi = new FileApi(context);
      const fileResponse = await fileApi.post(
        3,
        customerInfo?.cellPhone!,
        installAddress,
        agentCode,
        "",
        "",
        ""
      );

      if (fileResponse && fileResponse.id) {
        context.setActiveFileId(fileResponse.id);
        navigate("/");
      } else {
        alert(fileResponse.errorMessage || "خطایی رخ داده است.");
      }
    } catch (error) {
      console.error("File API error:", error);
    }
  };

  return (
    <React.Fragment>
      <div className="pt-10">
        {!isVerifying ? (
          <Form submit={onSubmit} handleSubmit={handleSubmit}>
            <h3 className="lead-title pt-2">{t("Title")}</h3>
            <Textbox
              {...register("agentCode")}
              label="کد نمایندگی"
              helpNote="در صورتی که توسط یک نماینده جهت ثبت نام معرفی شده اید."
              onChange={(e) => setAgentCode(e.target.value)}
              defaultValue={agentCode}
            />
            <Textarea
              {...register("installAddress")}
              label="آدرس نصب"
              helpNote="در صورت نیاز به نصب مودم توسط کارشناس شرکت، تعیین آدرس مراجعه مورد نیاز است."
              onChange={(e) => setInstallAddress(e.target.value)}
              defaultValue={installAddress}
            />
            <div className="form-section rtl flex flex-grow xs:flex-col sm:flex-row  gap-4 justify-between">
              <div className="rule-section flex algin-center items-center gap-2">
                <input
                  id="role-checkbox"
                  type="checkbox"
                  tabIndex={19}
                  onClick={() => setToggle(!toggle)}
                />
                <label className="role-checkbox-label" htmlFor="role-checkbox">
                  <p className="w-50">
                    {t("I had read and accept the contract", {
                      name: `${customerInfo?.firstName ?? ""} ${
                        customerInfo?.lastName ?? ""
                      }`,
                      nationalCode: localizeNumbers(
                        customerInfo?.nationalCode!
                      ),
                      service: "Fd-Lte",
                      username: localizeNumbers(customerInfo?.cellPhone!),
                    })}
                    <small>
                      <Link to="/signin" className="btn-show-role font-bold">
                        ({t("Read contract")})
                      </Link>
                    </small>
                  </p>
                </label>
              </div>
            </div>
            <div className="rule-section flex algin-center items-center gap-2">
              <button
                disabled={toggle}
                className="signup-btn p-5 flex"
                tabIndex={20}
              >
                {t("Accept & Continue")}
                <span className="sepanta-icon-left-long-arrow"></span>
              </button>
            </div>
          </Form>
        ) : (
          <VerifyNumber
            username={customerInfo?.cellPhone!}
            onSubmit={onVerifyNumberSubmit}
            handleAlert={(msg) => alert(msg)}
            alert={false}
            serviceType={"Fd-Lte"}
          />
        )}
      </div>
    </React.Fragment>
  );
}

export default RequestFd;
